




























import { TemplateSubmission } from "@/model/interfaces/submission/templateSubmission/templateSubmission"
import TemplateSubmissionModule from "@/store/modules/submission/TemplateSubmissionModule"

import { Component, Vue } from "vue-property-decorator"
import Button from "@/components/inputs/Button.vue"
import LayoutOverviewColumn from "@/components/layouts/LayoutOverviewColumn.vue"

@Component({
  components: {
    Button,
    LayoutOverviewColumn
  }
})
export default class OverviewTableSurveyPlan extends Vue {
  get submissions(): Array<TemplateSubmission> {
    return TemplateSubmissionModule.submissions
  }
}
